import { Box } from '@chakra-ui/react';
import { DeliveryOrderItem } from '@diamond/shared/types';

import { ReasonAlertBox } from './ReasonAlertBox';
import { ReasonAlertItem } from './types';
import { groupItemsByReason } from './utils';

export interface PodReasonsSectionProps {
  items: DeliveryOrderItem[];
}

/**
 * Displays POD (Proof of Delivery) rejection reasons for DO items
 * Shows red alert boxes grouped by rejection reason (e.g., "Rusak", "Salah kirim")
 */
export function PodReasonsSection({ items }: PodReasonsSectionProps) {
  const itemsWithReason = items.filter((item) => item.pod_reason);
  if (itemsWithReason.length === 0) return null;

  const mappedItems: ReasonAlertItem[] = itemsWithReason.map((item) => ({
    product_name: item.product_name,
    quantity: item.ordered_quantity,
    sales_unit: item.sales_unit,
  }));
  const reasons = itemsWithReason.map((item) => item.pod_reason);
  const groupedByReason = groupItemsByReason(mappedItems, reasons);

  return (
    <Box mt={2} data-testid="pod-reasons-section">
      <ReasonAlertBox groupedItems={groupedByReason} />
    </Box>
  );
}
